export default __webpack_public_path__ + "static/media/path.f68107af.svg";